// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__nyngb","footer":"ModalCreateQualiphyProcedure_footer__2yONh","additionData":"ModalCreateQualiphyProcedure_additionData__2Itu4"};